module.exports = "https://cdn.dove.it/_next/static/public/assets/properties/caseinvendita.d884e9071d526914a4736da4aa3500e1.jpg";